export default class ChartOptions {
    constructor(attributes = {}) {
        Object.assign(this, attributes)
    }
}
